import React, { useEffect, useState } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    Container,
    Grid,
    Paper,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    OutlinedInput,
    Checkbox,
    ListItemText
} from '@mui/material';
import swal from 'sweetalert';
import ConferenceNavbar from "../../../frontend/Conference/ConferenceNavbar";
import NewVersionAbstractFooter from "../../AbstractAuth/NewVersion/NewVersionAnstractFooter";
import axios from 'axios';

const ClaimCoupon = () => {
    const eventid = localStorage.getItem('eventid');
    const [successMessage, setSuccessMessage] = useState('');
    const [couponCode, setCouponCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [appliedCoupons, setAppliedCoupons] = useState([]); // <-- To display applied coupons
    const [disabled, setDisabled] = useState(false);
    const [hasDownloaded, setHasDownloaded] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        selectedCategory: '',
        selectedConferences: [],
        eventid: eventid
    });

    const [categories, setCategories] = useState([]);
    const [conferences, setConferences] = useState([]);
    const [savedConferences, setSavedConferences] = useState([]);
    const [responseMessage, setResponseMessage] = useState('');
    const [couponCodes, setCouponCodes] = useState([]);
    useEffect(() => {
        axios.get(`/api/conference-category-front-index?id=${eventid}`)
            .then(res => {
                setCategories(res.data.conferenceCategories || []);
            })
            .catch(err => console.error('Error loading categories:', err));
    }, [eventid]);

    useEffect(() => {
        if (formData.selectedCategory) {
            axios.get(`/api/conference-category-front-single/${formData.selectedCategory}`)
                .then(res => {
                    setConferences(res.data.swsd?.conferences || []);
                })
                .catch(err => console.error('Error loading conferences:', err));
        } else {
            setConferences([]);
            setFormData(prev => ({ ...prev, selectedConferences: [] }));
        }
    }, [formData.selectedCategory]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleConferenceSelect = (event) => {
        const {
            target: { value },
        } = event;
        setFormData(prev => ({
            ...prev,
            selectedConferences: typeof value === 'string' ? value.split(',') : value,
        }));
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        setDisabled(true);
        setErrorMessage('');
        setSavedConferences([]);
        setCouponCodes([]);

        axios.post('/api/conference-claim-coupon', formData)
            .then(res => {
                setResponseMessage(res.data.message || "Success");

                // Handle successful conference saves
                if (Array.isArray(res.data.saved_for_conferences) && res.data.saved_for_conferences.length > 0) {
                    setSavedConferences(res.data.saved_for_conferences);
                    const codes = res.data.saved_for_conferences
                        .map(item => item.coupon_code)
                        .filter(code => !!code);
                    setCouponCodes(codes);
                } else if (res.data.coupon_code) {
                    setCouponCodes([res.data.coupon_code]);
                }

                setErrorMessage('');
                swal("Success", res.data.message, "success");

                setFormData({
                    name: '',
                    email: '',
                    mobile: '',
                    selectedCategory: '',
                    selectedConferences: [],
                    eventid: eventid  // Keep the eventid
                });

                setDisabled(false);
            })
            .catch(err => {
                if (err.response && err.response.status === 422) {
                    const responseData = err.response.data;
                    setResponseMessage(responseData.message || "Application failed");

                    // Handle both array and object style errors
                    if (Array.isArray(responseData.errors)) {
                        setErrorMessage(responseData.errors.join('\n'));
                    } else if (typeof responseData.errors === 'object') {
                        let errorMessages = '';
                        for (const key in responseData.errors) {
                            if (responseData.errors.hasOwnProperty(key)) {
                                errorMessages += `${responseData.errors[key].join(' ')}\n`;
                            }
                        }
                        setErrorMessage(errorMessages);
                    }

                    // Check if there are any saved conferences despite errors
                    if (Array.isArray(responseData.saved_for_conferences)) {
                        setSavedConferences(responseData.saved_for_conferences);
                        const codes = responseData.saved_for_conferences
                            .map(item => item.coupon_code)
                            .filter(code => !!code);
                        setCouponCodes(codes);
                    }

                    swal("Error", responseData.message || "Validation failed", "error");
                } else {
                    setErrorMessage('Failed to claim coupon');
                    setResponseMessage('');
                    swal("Failed", "Failed to claim coupon", "error");
                }
                setDisabled(false);
            });
    };

    return (
        <div>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <ConferenceNavbar />
            </Grid>
            <Typography variant="h5" align="center" gutterBottom>
                {savedConferences.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Your Booked Conferences Coupons: in

                        </Typography>
                        <Box component="ul" sx={{ pl: 2 }}>
                            {savedConferences.map((conf, index) => (
                                <Box component="li" key={index} sx={{ mb: 1, listStyle: 'none' }}>
                                    <Typography>
                                        <strong>{conf.conference_name}</strong> -
                                        {/* {conf.conference_name && `conference: ${conf.conference_name}, `} -  */}
                                        {conf.conference_day && `Day: ${conf.conference_day}, `}
                                        Coupon: <code>{conf.coupon_code}</code>
                                    </Typography>
                                </Box>
                            ))}
                        </Box>

                        {/* Add Download Button */}
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{ mt: 2 }}
                            disabled={hasDownloaded}
                            onClick={() => {
                                // Create text content
                                let textContent = `Conference Claim Coupon\n\n`;
                                savedConferences.forEach((conf, index) => {
                                    textContent += `${index + 1}. ${conf.conference_name}\n`;
                                    textContent += `   Day: ${conf.conference_day || 'N/A'}\n`;
                                    textContent += `   Coupon Code: ${conf.coupon_code}\n\n`;
                                });

                                // Create download link
                                const element = document.createElement('a');
                                const file = new Blob([textContent], { type: 'text/plain' });
                                element.href = URL.createObjectURL(file);
                                element.download = 'conference_claim_coupon.txt';
                                document.body.appendChild(element);
                                element.click();
                                document.body.removeChild(element);

                                // Disable the button after download
                                setHasDownloaded(true);

                                // Optional: Show a message that download was successful
                                swal("Success", "Coupon details downloaded successfully!", "success");

                            }}
                        >
                            {hasDownloaded ? "Downloaded" : "Download Claim Coupons Details"}
                        </Button>
                    </Box>
                )}
                {/* Display error messages if any */}
                {errorMessage && (
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle1" color="error">
                            Issues encountered:
                        </Typography>
                        {errorMessage.split('\n').map((msg, index) => (
                            <Typography key={index} color="error">
                                {msg}
                            </Typography>
                        ))}
                    </Box>
                )}
            </Typography>


            <Container maxWidth="md" sx={{ mt: 5 }}>
                <Paper elevation={3} sx={{ padding: 4, borderRadius: 3 }}>
                    <Typography variant="h5" align="center" gutterBottom>
                        Claim Your Coupon
                    </Typography>

                    <Box component="form" onSubmit={handleSubmit} noValidate>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    label="Full Name"
                                    name="name"
                                    fullWidth
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Email Address"
                                    name="email"
                                    type="email"
                                    fullWidth
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Mobile Number"
                                    name="mobile"
                                    type="tel"
                                    fullWidth
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth required>
                                    <InputLabel>Select Conference Category</InputLabel>
                                    <Select
                                        name="selectedCategory"
                                        value={formData.selectedCategory}
                                        onChange={handleChange}
                                        input={<OutlinedInput label="Select Conference Category" />}
                                    >
                                        {categories.map((cat) => (
                                            <MenuItem key={cat.id} value={cat.id}>
                                                {cat.conference_category_title}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {formData.selectedCategory && (
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <InputLabel>Select Conferences</InputLabel>
                                        <Select
                                            multiple
                                            value={formData.selectedConferences}
                                            onChange={handleConferenceSelect}
                                            input={<OutlinedInput label="Select Conferences" />}
                                            renderValue={(selected) =>
                                                conferences
                                                    .filter(c => selected.includes(c.id))
                                                    .map(c => c.conference_name)
                                                    .join(', ')
                                            }
                                        >
                                            {conferences
                                                ?.filter(conf => conf.claim_coupon_status === 1 && conf.conference_coupon === 1)
                                                .map((conf) => (
                                                    <MenuItem key={conf.id} value={conf.id}>
                                                        <Checkbox checked={formData.selectedConferences.indexOf(conf.id) > -1} />
                                                        <ListItemText
                                                            primary={`${conf.conference_name} - Day: ${conf.conference_day}, Date: ${conf.conference_date}, Timing: (${conf.conference_start_time} to ${conf.conference_end_time})`}
                                                        />
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    disabled={disabled}

                                >
                                    {disabled ? 'Processing...' : 'Claim Coupon'}
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>


                </Paper>
            </Container>

            <Grid item xs={12} sm={10} md={8} lg={6} mt={5}>
                <NewVersionAbstractFooter />
            </Grid>
        </div>
    );
};

export default ClaimCoupon;
